export default "__VITE_ASSET__UVXhH0ZR__"